import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-container" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "container flex-grow-1 updateorder" }
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "input-group mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "input-group-text",
    id: "fullname"
  }, "Name")
], -1)
const _hoisted_9 = { class: "input-group mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "input-group-text",
    id: "plate"
  }, "Plate #")
], -1)
const _hoisted_11 = { class: "input-group mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "input-group-text",
    id: "make"
  }, "Make")
], -1)
const _hoisted_13 = { class: "input-group mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "input-group-text",
    id: "model"
  }, "Model")
], -1)
const _hoisted_15 = { class: "input-group mb-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "input-group-text",
    id: "color"
  }, "Color")
], -1)
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "input-group-text",
    id: "vin"
  }, "VIN")
], -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "button-group" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Capture/Select Image ")
const _hoisted_22 = {
  key: 0,
  class: "pi pi-spin pi-spinner"
}
const _hoisted_23 = { class: "button-group bottom" }
const _hoisted_24 = {
  key: 0,
  class: "image"
}
const _hoisted_25 = ["src"]

import { computed } from 'vue';
import { ref } from "@vue/reactivity";
import { useRoute, useRouter } from 'vue-router';
import { useAuth0 } from "@auth0/auth0-vue";
import { MutationTypes } from "../store/mutations";
import { useStore } from "../store";
import { useVuelidate } from '@vuelidate/core';
import { required, minLength, maxLength, helpers } from '@vuelidate/validators';
import ErrorModal from './ErrorModal.vue';
import { openErrorModal } from '@/composables/useErrorLog';


export default /*#__PURE__*/_defineComponent({
  name: 'UpdateOrder',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const workordernumber = route.params.workordernumber;
const store = useStore();
store.commit(MutationTypes.SET_CURRENTWO_BYID, workordernumber);
let currentWO = store.getters.getCurrentWO;
const serviceitemid = currentWO?.ServiceItemID;
const lastname = currentWO?.LastName;
const firstname = currentWO?.FirstName;
const make = currentWO?.Make;
const model = currentWO?.Model;
const color = currentWO?.Color;
const vin = ref();
vin.value = currentWO?.VIN;
const plate = ref();
plate.value = currentWO?.Plate;
const previewphoto = ref();
previewphoto.value = null;
const photo = ref('');
const loading = ref(false);
const capture = ref(false);
const vinfocus = ref();
const auth0 = useAuth0();
const fullname = computed(() => firstname + " " + lastname);
const rules = computed(() => ({
    vin: { required: helpers.withMessage('VIN cannot be empty', required), minLength: helpers.withMessage('VIN must be 17 characters', minLength(17)), maxLength: helpers.withMessage('VIN must be 17 characters', maxLength(17)) },
}));
const v$ = useVuelidate(rules, { vin });

async function onSubmit() {
    if (!await v$.value.$validate()) return;
    const storeid = store.state.storeid;
    const WOurl = process.env.VUE_APP_NODEJS_BASE_URL + "workorders/" + storeid + "/" + serviceitemid;
    const accessToken = await auth0.getAccessTokenSilently();
    try {
        const response = await fetch(WOurl, {
            method: 'PATCH',
            body: JSON.stringify({
                VIN: vin.value,
                PlateNumber: plate.value,
            }),
            headers: {
                'content-type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
        });
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
        const store = useStore();
        store.commit(MutationTypes.UPDATE_VIN, { ServiceItemID: serviceitemid, VIN: vin.value, Plate: plate.value });
        router.go(-1);
    } catch (e) {
        openErrorModal(e.message);
    }
}

function handleCancel() {
    router.push({ name: 'workorders' });
}

function filesChange(fileList) {
    loading.value = true;
    const url = process.env.VUE_APP_VINOCR_URL;
    // handle file changes
    const formData = new FormData();
    if (!fileList.length) return;
    let reader = new FileReader;
    reader.onloadstart = () => { loading.value = true; console.log(loading.value); };
    reader.onloadend = () => { loading.value = false; console.log(loading.value); };
    reader.onload = (event) => {
        //optimize image
        const imgElement = document.createElement("img");
        imgElement.src = event.target.result;
        imgElement.onload = function (e) {
            capture.value = false;
            const canvas = document.createElement("canvas");
            const MAX_WIDTH = 480;
            const scaleSize = MAX_WIDTH / e.target.width;
            canvas.width = MAX_WIDTH;
            canvas.height = e.target.height * scaleSize;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(e.target, 0, 0, canvas.width, canvas.height);
            const srcEncoded = ctx.canvas.toDataURL(e.target, "image/jpeg");
            // you can send srcEncoded to the server, base64
            previewphoto.value = srcEncoded;
            //convert base64 to blob
            const base64 = srcEncoded;
            var img2 = base64.replace("data:", "").replace(/^.+,/, "");
            const byteCharacters = atob(img2);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const img = new Blob([byteArray], { type: 'image/jpeg' });
            formData.append('file', img);
            //call VINOCR API
            var xHttp = new XMLHttpRequest();
            xHttp.open("POST", url, false);
            xHttp.send(formData);
            var jsonResponse = JSON.parse(xHttp.responseText);
            if (jsonResponse.status === 'SUCCESS')
                vin.value = jsonResponse.vin_captured;
            else
                vin.value = 'FAILED';
        };
    };
    reader.readAsDataURL(fileList[0]);
}

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ErrorModal),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, "Workorder: #" + _toDisplayString(_unref(workordernumber)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", {
        onSubmit: _withModifiers(onSubmit, ["prevent"]),
        class: "card p-3 border",
        id: "form"
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_InputText, {
              type: "text",
              class: "border form-control",
              value: _unref(fullname),
              readonly: ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_InputText, {
              type: "text",
              class: "border form-control",
              modelValue: plate.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((plate).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_InputText, {
              type: "text",
              class: "border form-control",
              value: _unref(make),
              readonly: ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_InputText, {
              type: "text",
              class: "border form-control",
              value: _unref(model),
              readonly: ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_InputText, {
              type: "text",
              class: "border form-control",
              value: _unref(color),
              readonly: ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_InputText, {
              type: "text",
              class: "border form-control",
              modelValue: vin.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((vin).value = $event)),
              onFocus: _cache[2] || (_cache[2] = ($event: any) => (vinfocus.value = true)),
              onBlur: _cache[3] || (_cache[3] = ($event: any) => (vinfocus.value = false))
            }, null, 8, ["modelValue"]),
            (_unref(v$).vin.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(v$).vin.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", {
              for: "files",
              class: "p-button p-button-rounded btn-primary mt-3",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (capture.value = true))
            }, [
              _hoisted_21,
              (capture.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_22))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("input", {
              type: "file",
              id: "files",
              class: "files",
              onChange: _cache[5] || (_cache[5] = ($event: any) => (filesChange($event.target.files)))
            }, null, 32)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_Button, {
              type: "submit",
              class: "p-button-rounded btn-secondary ml-2",
              label: "Update"
            }),
            _createVNode(_component_Button, {
              label: "Cancel",
              class: "p-button-rounded btn-secondary ml-2",
              onClick: handleCancel
            })
          ])
        ]),
        (previewphoto.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("img", {
                src: previewphoto.value,
                alt: "",
                ref_key: "photo",
                ref: photo
              }, null, 8, _hoisted_25)
            ]))
          : _createCommentVNode("", true)
      ], 40, _hoisted_5)
    ])
  ], 64))
}
}

})